// extracted by mini-css-extract-plugin
export default {"modalContentContainer":"EditTaskModal_modalContentContainer__5zwGC","leftSection":"EditTaskModal_leftSection__GGoJt","rightSection":"EditTaskModal_rightSection__o+IvP"};